<template>
    <div class="banner">
        <div class="img left"></div>
        <div class="content">
            <span class="msg">Скачайте приложение</span>
            <span class="title">«Наставничество»</span>
            <div class="stores">
                <a href="https://apps.apple.com/ru/app/id1502526382" class="btn as"></a>
                <a href="https://play.google.com/store/apps/details?id=rsvmobile.rsv_mobile" class="btn gp"></a>
            </div>
        </div>
        <div class="img right"></div>
    </div>
</template>

<script>
export default {
    name: 'Banner',
};
</script>

<style lang="scss" scoped>
@import "@/styles/variables";
@import '@/styles/rem';
@import '@/styles/mrem';

.banner{
    display: flex;
    align-items: stretch;
    justify-content: space-between;
    width: 100%;
    height: rem(170);
    background-color: #ffffff;
    border-radius: rem(4);
    overflow: hidden;
    @include on-mobile{
        height: mrem(118);
        border-radius: mrem(4);
    }
    .img{
        width: rem(150);
        &.left{
            background: url('../../../../assets/images/account/mentoring/banner-left.png') no-repeat center/contain;
        }
        &.right{
            background: url('../../../../assets/images/account/mentoring/banner-right.png') no-repeat center/contain;
        }
        @include on-mobile{
            width: mrem(74);
            height: mrem(84);
        }
    }
    .content{
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: rem(24) 0;
        @include on-mobile{
            padding: mrem(16) 0;
        }
        .msg{
            font-weight: 600;
            font-size: rem(16);
            line-height: rem(24);
            color: #2A2626;
            @include on-mobile{
                font-size: mrem(12);
                line-height: mrem(18);
            }
        }
        .title{
            font-weight: 600;
            font-size: rem(28);
            line-height: rem(36);
            color: #2A2626;
            @include on-mobile{
                font-size: mrem(20);
                line-height: mrem(28);
            }
        }
        .stores{
            display: flex;
            margin-top: auto;
            .btn{
                width: rem(154);
                height: rem(47);
                @include on-mobile{
                    width: mrem(104);
                    height: mrem(32);
                }
                &.as{
                    background: url('../../../../assets/images/account/mentoring/as.svg') no-repeat center/contain;
                    margin-right: rem(16);
                    @include on-mobile{
                        margin-right: mrem(16);
                    }
                }
                &.gp{
                    background: url('../../../../assets/images/account/mentoring/gp.svg') no-repeat center/contain;
                }
            }
        }
    }
}
</style>